import repeatDataHandlerCardcode from './repeat_data_handler_cardcode.vue'
import { createCmpEngine } from '@/utils'

export const openRepeatDataHandlerCardCode = createCmpEngine(repeatDataHandlerCardcode)
